import { render, staticRenderFns } from "./RegisterWards.vue?vue&type=template&id=2c13ea32&"
import script from "./RegisterWards.vue?vue&type=script&lang=js&"
export * from "./RegisterWards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports